<div class="ord-select-wrapper flex flex-col">
  @if(label) {
  <label [for]="id" class="ord-form-field-label"
    >{{ label }}
    @if (required) {
    <span class="ord-form-field-required">*</span>
    }
  </label>
  }
  @if (options.length === 0 && hasContentIfEmpty) {
  <ng-container [ngTemplateOutlet]="contentIfEmpty.templateRef"></ng-container>
  } @else {
  <mat-form-field
    appearance="outline"
    color="accent"
    class="ord-form-field ord-select"
  >
    <mat-select
      class="ord-select"
      panelClass="ord-select-panel"
      [placeholder]="placeholder ?? (allowMultipleSelection ? 'Select item(s)' : 'Select item')"
      [formControlName]="controlName"
      [multiple]="allowMultipleSelection"
    >
      <mat-select-trigger>{{
        getTriggerLabel() ?? placeholder
      }}</mat-select-trigger>
      @if(resettable) {
      <mat-option [value]="null" class="ord-option"> None </mat-option>
      } @for (option of options; track trackById($index, option)) {
      @if(isFilterOptionGroup(option)) {
      <!-- TODO: Add code if grouped options should be supported  -->
      }@else {
      <mat-option
        [value]="option.value"
        class="ord-option"
        [disabled]="option.disabled"
      >
        <div class="ord-option--content">
          <p class="ord-option--label">{{ option.label }}</p>
          @if(option.description && showDescription) {
          <p class="ord-option--description">{{ option.description }}</p>
          }
        </div>
      </mat-option>
      } }
    </mat-select>
    @if (control.hasError('required')) {
    <mat-error class="ord-error">{{ label }} is required.</mat-error>
    }
  </mat-form-field>
  }
</div>
